import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './vijaya logo.png';
import small_logo from './vdc_logo.png';
import { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const Sidebar = ({ isOpen: propIsOpen }) => {
  useAuth();
  const [hovered, setHovered] = useState(false);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [checkboxStates, setCheckboxStates] = useState({});
  const [loading, setLoading] = useState(true);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [reportLoading, setReportLoading] = useState(false);

  const isOpen = hovered || propIsOpen; // Expanded on hover or permanently open

  const toggleDropdown = (id) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    const fetchEmpList = async () => {
      const token = localStorage.getItem('authToken');

      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BASE_URL}emp_list_code`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (data.status && Array.isArray(data.data)) {
          setUsers(data.data);

          const user = data.data[0]; // assuming only one user is returned

          setCheckboxStates({
            admin_role: user.admin_role === 'Y',
            super_admin_role: user.super_admin_role === 'Y',
            employee_role: user.employee_role === 'Y',
            branch_manager_role: user.branch_manager_role === 'Y',
            candidate_role: user.candidate_role === 'Y',
          });
          //  setCheckboxStates(checkboxMap);

        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError('Failed to fetch employee list');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpList();
  }, []);

  const downloadStockValidationReport = async () => {

  const confirmed = window.confirm(
    'Are you sure you want to download the Physical Stock Summary report?'
  );

  if (!confirmed) return;

  setReportLoading(true);

  try {

    const response = await fetch(
      'https://uniform.vdcapp.in/backend/api/stock_validation_report',
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch report');
    }

    const result = await response.json();

    console.log('Stock Validation API Response:', result);

    /*
    ==========================================
    API RESPONSE:
    
    {
      "employees": [
        {
          "area_name": "Bangalore-Stores",
          "uniform_type": "Shirts",
          "uniform_size": "34",
          "uniform_color": "Blue",
          "gender": "Female",
          "grn_quantity": "0",
          "delivered_qty": "0",
          "pending_qty": "0",
          "physical_stock": "0",
          "remaining_stock": "0",
          "sys_stock": "0",
          "variance": "0"
        }
      ]
    }
    ==========================================
    */

    const employees = result.employees;

    if (!Array.isArray(employees) || employees.length === 0) {

      alert('No stock data available to download');

      return;
    }


    /*
    ==========================================
    CONVERT API DATA TO EXCEL DATA
    ==========================================
    */

    const excelData = employees.map((item, index) => ({

      'S.No': index + 1,

      'Area': item.area_name || '',

      'Uniform Type': item.uniform_type || '',

      'Uniform Size': item.uniform_size || '',

      'Uniform Color': item.uniform_color || '',

      'Gender': item.gender || '',

      'GRN Quantity': Number(item.grn_quantity || 0),

      'Delivered Quantity': Number(item.delivered_qty || 0),

      'Pending Quantity': Number(item.pending_qty || 0),

      'Physical Stock': Number(item.physical_stock || 0),

      'Remaining Stock': Number(item.remaining_stock || 0),

      'System Stock': Number(item.sys_stock || 0),

      'Variance': Number(item.variance || 0),

    }));


    /*
    ==========================================
    CREATE EXCEL WORKSHEET
    ==========================================
    */

    const worksheet = XLSX.utils.json_to_sheet(excelData);


    /*
    ==========================================
    SET COLUMN WIDTHS
    ==========================================
    */

    worksheet['!cols'] = [

      { wch: 8 },   // S.No

      { wch: 25 },  // Area

      { wch: 18 },  // Uniform Type

      { wch: 15 },  // Uniform Size

      { wch: 18 },  // Uniform Color

      { wch: 12 },  // Gender

      { wch: 15 },  // GRN Quantity

      { wch: 20 },  // Delivered Quantity

      { wch: 18 },  // Pending Quantity

      { wch: 18 },  // Physical Stock

      { wch: 20 },  // Remaining Stock

      { wch: 15 },  // System Stock

      { wch: 12 },  // Variance

    ];


    /*
    ==========================================
    CREATE WORKBOOK
    ==========================================
    */

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Physical Stock'
    );


    /*
    ==========================================
    GENERATE XLSX FILE
    ==========================================
    */

    const wbout = XLSX.write(workbook, {

      bookType: 'xlsx',

      type: 'array',

    });


    /*
    ==========================================
    DOWNLOAD FILE
    ==========================================
    */

    saveAs(

      new Blob(
        [wbout],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }
      ),

      'Stock_Validation_Report.xlsx'

    );

  } catch (error) {

    console.error(
      'Error downloading stock validation report:',
      error
    );

    alert(
      'Error downloading report: ' + error.message
    );

  } finally {

    setReportLoading(false);

  }

};





  return (
    <aside
      className={`menu-sidebar d-none d-lg-block bg-white`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: isOpen ? '300px' : '100px',
        overflow: 'hidden',
        transition: 'width 0.3s ease',
        position: 'fixed',
        height: '100vh',
        top: 0,
        left: 0,
        zIndex: 1030,
      }}
    >
      <div className="logo d-flex align-items-center justify-content-center p-3">
        <a href="#">
          <img
            src={isOpen ? logo : small_logo}
            alt="Logo"
            style={{
              height: isOpen ? '50px' : '40px',
              width: 'auto',
              transition: 'all 0.3s ease',
            }}
          />
        </a>
      </div>

      <div
        className="menu-sidebar__content"
        style={{
          overflowY: "auto",
          height: "calc(100vh - 80px)",
        }}
      >
        <nav className="navbar-sidebar">
          <ul className="list-unstyled navbar__list">
            <li>
              <Link to="/dashboard" className="d-flex align-items-center">
                <i className="fas fa-tachometer-alt me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Dashboard</span>}
              </Link>
            </li>

            {/* <li>
              <Link to="/dashboard2" className="d-flex align-items-center">
                <i className="fas fa-tachometer-alt me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Dashboard - 2</span>}
              </Link>
            </li> */}

            {/* Candidates - Visible if candidate_role or super_admin */}
            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role) && (
              <li>
                <Link to="/manage_employee" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Issue Uniforms</span>}
                </Link>
              </li>
            )}

            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role) && (
              <li>
                <Link to="/manage_return_stock" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Return Uniform Approval</span>}
                </Link>
              </li>
            )}

            <li>
                <Link to="/manage_myexchange_uniforms" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">My Exchange Uniforms</span>}
                </Link>
              </li>

            {/* Reports - Optional: only for super_admin or both roles */}

            {(checkboxStates.super_admin_role || checkboxStates.branch_manager_role) && (
              <li>
                <Link to="/manage_indent" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Indent</span>}
                </Link>
              </li>
            )}
            {/* Users - Show only to super admin */}
            {checkboxStates.super_admin_role && (
              <li>
                <Link to="/emp_list" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Users</span>}
                </Link>
              </li>
            )}

            {/* Employee - if employee_role or super_admin */}
            {/* {(checkboxStates.employee_role || checkboxStates.super_admin_role) && (
              <li>
                <Link to="/manage_employee" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Employee</span>}
                </Link>
              </li>
            )} */}

            {/* Settings - Only for super_admin */}

            {(checkboxStates.super_admin_role || checkboxStates.admin_role) && (<li>
              <Link to="/manage_stocks" className="d-flex align-items-center">
                <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Stock Details</span>}
              </Link>
            </li>)}

            {(checkboxStates.super_admin_role) && (<li>
              <Link to="/manage_transfers" className="d-flex align-items-center">
                <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Transfer Details</span>}
              </Link>
            </li>)}

            <li className="has-sub">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('settings');
                }}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center">
                  <i className="fas fa-cog me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span>Settings</span>}
                </div>
                {isOpen && (
                  <i className={`fas fa-angle-${openDropdowns['settings'] ? 'down' : 'left'}`}></i>
                )}
              </a>

              {isOpen && openDropdowns['settings'] && (
                <ul className="list-unstyled ms-4 mt-2">
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresstype"><i className="fas fa-angle-right me-2"></i><span>Dress Type</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresssize"><i className="fas fa-angle-right me-2"></i><span>Dress Size</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresscolor"><i className="fas fa-angle-right me-2"></i><span>Dress Colour</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_mapping"><i className="fas fa-angle-right me-2"></i><span>Mapping</span></Link></li>)}

                  {checkboxStates.super_admin_role && (<li><Link to="/manage_areas"><i className="fas fa-angle-right me-2"></i><span>Areas</span></Link></li>)}
                </ul>
              )}
            </li>

            

            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
              <a
                href="#"
                className="d-flex align-items-center"
                onClick={e => {
                  e.preventDefault(); 
                  downloadStockValidationReport();
                }}
              >
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Stock valdiation report</span>}
              </a>
            </li>)}


            {/* (checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
              <a
                href="#"
                className="d-flex align-items-center"
                onClick={e => {
                  e.preventDefault();
                  downloadReportemployeePaid();
                }}
              >
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Employee Purchased Report</span>}
              </a>
            </li>)}

            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
              <a
                href="#"
                className="d-flex align-items-center"
                onClick={e => {
                  e.preventDefault();
                  downloadReportStockTransfer();
                }}
              >
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Stock Transfer Report</span>}
              </a>
            </li>)}

            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
              <a
                href="#"
                className="d-flex align-items-center"
                onClick={e => {
                  e.preventDefault();
                  downloadReportGrnReport();
                }}
              >
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">All Cities Grn Report</span>}
              </a>
            </li>)}

            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li><Link to="/overall_stock_reports"><i className="fas fa-chart-bar me-2"></i><span>Over All Stock Balance Report</span></Link></li>)}
            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li><Link to="/opening_stock_report"><i className="fas fa-chart-bar me-2"></i><span>Opening Stock Report</span></Link></li>)}
            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li><Link to="/area_wise_shirt_trouser"><i className="fas fa-chart-bar me-2"></i><span>Date Wise Consumed Report</span></Link></li>)}
            {(checkboxStates.super_admin_role || checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.branch_manager_role) && (
            <li>
                <Link to="/manage_stock_reports" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Stock Reports</span>}
                </Link>
              </li>
            )}
            <li>
              {checkboxStates.super_admin_role && (<Link to="/manage_backend" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Backend Payment Update</span>}
              </Link>)}
            </li> */}


            {/* {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
              <Link to="/grn_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">GRN Reports</span>}
              </Link>
            </li>)} */}


            {/* {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role || checkboxStates.branch_manager_role) && (<li>
             <Link to="/consumption_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Consumption Reports</span>}
              </Link>
            </li>)} */}




            {/* <li>
            <Link to="/area_wise_payment_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Area Wise Payment</span>}
              </Link>
            </li> */}

            {/* <li>
            <Link to="/area_wise_shirt_trouser" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Date Wise Consumed Report</span>}
              </Link>
            </li> */}
            {/* <li>
            <Link to="/focus_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Focus Report</span>}
              </Link>
            </li> */}
            {/* {(checkboxStates.admin_role) && (
              <>
            <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReport();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">All Area Stock Report</span>}
          </a>
            </li>
          <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReportemployeePaid();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">Employee Paid Report</span>}
          </a>
            </li>
          <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReportStockOut();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">Stock Out Report</span>}
          </a>
            </li></>)} */}

          </ul>
        </nav>
      </div>
      {reportLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <div
            className="spinner-border text-light"
            role="status"
            style={{ width: '4rem', height: '4rem' }}
          >
            <span className="sr-only">Loading...</span>
          </div>

          <h4 style={{ color: '#fff', marginTop: '20px' }}>
            Generating Employee Purchased Report...
          </h4>

          <p style={{ color: '#fff' }}>
            Please wait, this may take up to 1 minute.
          </p>
        </div>
      )}

    </aside>

  );
};


export default Sidebar;
